import { render, staticRenderFns } from "./FiltroDaAgenda.vue?vue&type=template&id=e9565136"
import script from "./FiltroDaAgenda.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiltroDaAgenda.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports